<source *ngIf="data.webp && data.mobile"
  srcset="/assets/img/{{ data.image }}_s.webp, /assets/img/{{ data.image }}_s@2x.webp 2x" media="(max-width: 991px)"
  type="image/webp" />
<source *ngIf="data.mobile"
  srcset="/assets/img/{{ data.image }}_s.{{ data.format === '' ? 'png' : data.format }}, /assets/img/{{ data.image }}_s@2x.{{ data.format === '' ? 'png' : data.format }} 2x"
  media="(max-width: 991px)" />
<source *ngIf="data.webp && data.mobile"
  srcset="/assets/img/{{ data.image }}.webp, /assets/img/{{ data.image }}@2x.webp 2x" media="(min-width: 992px)"
  type="image/webp" />
<source *ngIf="data.mobile"
  srcset="/assets/img/{{ data.image }}.{{ data.format === '' ? 'png' : data.format }}, /assets/img/{{ data.image }}@2x.{{ data.format === '' ? 'png' : data.format }} 2x"
  media="(min-width: 992px)" />
<source *ngIf="!data.mobile && data.webp"
  srcset="/assets/img/{{ data.image }}.webp, /assets/img/{{ data.image }}@2x.webp 2x" type="image/webp" />
<source *ngIf="!data.mobile"
  srcset="/assets/img/{{ data.image }}.{{ data.format === '' ? 'png' : data.format }}, /assets/img/{{ data.image }}@2x.{{ data.format === '' ? 'png' : data.format }} 2x" />

<img *ngIf="!data.fill" [ngSrc]="url" alt="{{ data.altext }}" title="{{ data.title }}" [width]="data.width"
  [height]="data.height" [attr.id]="data.id ? data.id : null" class="img-fluid {{ data.classes }}"
  [fill]="data.fill" />

<img *ngIf="data.fill" [ngSrc]="url" alt="{{ data.altext }}" title="{{ data.title }}"
  [attr.id]="data.id ? data.id : null" class="img-fluid {{ data.classes }}" [fill]="data.fill" />